import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user');

const state = {
}

const mutations = {
}

const getters = {
}

const actions = {
  getCardData (context, cardId) {
    return UserRepository.getAnnualTicket(cardId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
